// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.2-next',
  revision: '20638fb0a',
  branch: 'next',
  date: 'Tue, 30 Jun 2026 13:32:10 GMT'
};